/**
 * Web-specific event types that trigger data collection.
 * Mirrors Android TrackerEventType but adapted for browser environment.
 */
export enum TrackerEventType {
  PAGE_VIEW = "PAGE_VIEW",
  CLICK = "CLICK",
  SCROLL = "SCROLL",
  CUSTOM = "CUSTOM",
  RISK_ALERT = "RISK_ALERT",
  VISIBILITY_CHANGE = "VISIBILITY_CHANGE",
  IDLE = "IDLE",
  FORM_INTERACTION = "FORM_INTERACTION",
  COPY_PASTE = "COPY_PASTE",
}
